import { ApolloProvider } from "@apollo/client";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { darkTheme, lightTheme } from "Muitheme";
import CustomToast from "components/Toast/toast";
import { useThemeMode } from "hooks/useThemeMode";
import { useLayoutEffect } from "react";
import { useSelectors } from "redux-store/selectors";
import { graphQlClient } from "services/graphql/config";
import MyRoutes from "./routers";
import DocumentLoadContextProvider from "hooks/useDocumentLoading";

function App() {
  const { theme } = useSelectors();
  const { toDark, toLight } = useThemeMode();

  useLayoutEffect(() => {
    if (localStorage.theme === "dark") {
      toDark();
    } else {
      toLight();
    }
  }, []);

  return (
    <ThemeProvider theme={theme.isDarkMode ? darkTheme : lightTheme}>
      <DocumentLoadContextProvider>
        <ApolloProvider client={graphQlClient}>
          <CssBaseline />
          <div className="bg-[#f8f8f8] text-base dark:bg-neutral-900/95 text-neutral-900 dark:text-neutral-200 font-body min-h-[100vh]">
            <MyRoutes />
            <CustomToast />
          </div>
        </ApolloProvider>
      </DocumentLoadContextProvider>
    </ThemeProvider>
  );
}

export default App;
